import { i18n } from '@/locales';
// eslint-disable-next-line no-shadow
var ESnackbarType;
(function (ESnackbarType) {
    ESnackbarType["SUCCESS"] = "success";
    ESnackbarType["ERROR"] = "error";
    ESnackbarType["INFO"] = "info";
})(ESnackbarType || (ESnackbarType = {}));
const snackbarDefaultMessage = {
    success: i18n.t('views.snackbar.success'),
    error: i18n.t('views.snackbar.fail'),
    info: i18n.t('views.snackbar.info'),
};
/**
 * 문자열을 배열로 치환 합니다.
 */
const convertStringToArray = (message, messageType) => {
    const tmp = [];
    if (!message) {
        tmp.push(snackbarDefaultMessage[messageType]);
        return tmp;
    }
    if (typeof message === 'string') {
        tmp.push(message);
        return tmp;
    }
    if (Array.isArray(message)) {
        tmp.push(...message);
        return tmp;
    }
    return tmp;
};
const mutations = {
    SET_SHOW: (state, show) => {
        state.show = show;
    },
    SHOW_SUCCESS: (state, payload = {
        message: '',
    }) => {
        const { message } = payload;
        state.message = convertStringToArray(message, ESnackbarType.SUCCESS);
        // state.message = payload.message ?? i18n.t('views.snackbar.success');
        state.messageProps = payload.messageProps ?? payload.messageProps;
        state.timeout = payload.timeout ?? state.timeout;
        state.show = true;
        state.status = 'success';
    },
    SHOW_ERROR_MESSAGE: (state, payload = {
        message: '',
    }) => {
        const _message = (typeof payload === 'string') ? payload : payload.message;
        state.message = convertStringToArray(_message, ESnackbarType.ERROR);
        // state.message = payload.message ?? i18n.t('views.snackbar.fail');
        state.messageProps = payload.messageProps ?? payload.messageProps;
        state.timeout = payload.timeout ?? state.timeout;
        state.show = true;
        state.status = 'error';
    },
    SHOW_INFO_MESSAGE: (state, payload = {
        message: '',
    }) => {
        const { message } = payload;
        state.message = convertStringToArray(message, ESnackbarType.INFO);
        // state.message = payload.message ?? i18n.t('views.snackbar.info');
        state.messageProps = payload.messageProps ?? payload.messageProps;
        state.timeout = payload.timeout ?? state.timeout;
        state.show = true;
        state.status = 'alert';
    },
};
export default mutations;
